const presential_pt = require('./presential.json')
export default presential_pt